module.exports = __webpack_public_path__ + "img/car1.d91697b6.png";